module.exports = __webpack_public_path__ + "static/img/title-brand-guidelines.21fb606.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title-brand-guidelines.svg
// module id = 1SLo
// module chunks = 0